import { Leg } from '../../types/strategy-entities';

export interface StrategyLegState {
  loading: boolean;
  loaded: boolean;
  pending: boolean;
  error?: string | undefined;
  legs: Leg[];
  ui: {
    [strategyId: string]: string | undefined;
  };
}

export const initialState: StrategyLegState = {
  loading: false,
  loaded: false,
  pending: false,
  legs: [],
  ui: {}
};
